// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1153":"bbaa99c9","4821":"3d47791b","7763":"32ae5203","8065":"b0caedfa","8859":"1f2987e2"}[chunkId] + ".chunk.css";
};